// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction4_wrapper__hT6XK","button":"introduction4_button__L8Ug5"};